import h from "trader-hyperscript";
import { rpc } from "trader.ts/network";
import { Form, selectBox } from "trader.ts/ui.forms";
import { studentid } from "../../../sql/classy/types";
import { renderSaveButton } from "../../client/savebutton";
import { renderFirstNameLastName } from "../../render";
import * as routes from "../../routes";

export function render(opts: {
  toStudent: { id: studentid; firstname: string; lastname: string };
  otherStudents: { id: studentid; firstname: string; lastname: string }[];
}): HTMLElement | HTMLElement[] {
  const form = new Form({})
    .addField("from_student", [], () =>
      selectBox({
        initial: undefined,
        values: opts.otherStudents.orderBy(renderFirstNameLastName),
        show: renderFirstNameLastName,
        label: "Welke student wil je bij %n voegen?".replace(
          "%n",
          opts.toStudent.firstname,
        ),
      }),
    )
    .build();
  return (
    <article>
      <h2>
        {"Geselecteerd: %n".replace(
          "%n",
          renderFirstNameLastName(opts.toStudent),
        )}
      </h2>
      <article>{form.render()}</article>

      <div style="text-align: right">
        {renderSaveButton({
          formS: form.s,
          save: (values) =>
            rpc(routes.mergeStudentSpec, undefined, {
              to_studentid: opts.toStudent.id,
              from_studentid: values.from_student.id,
            }),
          reload: true,
        })}
      </div>
    </article>
  );
}
